export const isDtiHosted =
  window.location.origin.toLowerCase().includes('dtinerds') || window.location.origin.toLowerCase().includes('dtiportal.com') || localStorage.getItem('use-dti-login') === 'yes'; // || window.location.origin.toLowerCase().includes('localhost'); // Uncomment this for local dev as needed

export const isRevProHosted = window.location.origin.toLowerCase().includes('revpro'); // || window.location.origin.toLowerCase().includes('localhost'); // Uncomment this for local dev as needed

export const isTKTEdgeHosted = window.location.origin.toLowerCase().includes('tktedge'); // || window.location.origin.toLowerCase().includes('localhost'); // Uncomment this for local dev as needed

export const isVictoryLiveHosted = window.location.hostname.toLowerCase() === 'autopricer.victorylive.com';

// True when the SPA is running inside the native mobile app's WebView, which injects
// window.__BARKER_NATIVE__ before the page loads and supplies the Auth0 token natively.
export const isNativeAppHosted = typeof window !== 'undefined' && !!(window as Window & { __BARKER_NATIVE__?: unknown }).__BARKER_NATIVE__;

export const isWhiteLabelHosted = isDtiHosted || isRevProHosted || isTKTEdgeHosted || isVictoryLiveHosted;

export const supportEmail = isDtiHosted
  ? 'members@dtimanagement.com'
  : isVictoryLiveHosted
    ? 'consignment@victorylive.com'
    : isRevProHosted
      ? 'help@revpro.co'
      : isTKTEdgeHosted
        ? 'help@tktedge.com'
        : 'support@brokernerds.com';

export const supportName = isRevProHosted
  ? 'RevPro Management Services'
  : isDtiHosted
    ? 'DTI Management'
    : isTKTEdgeHosted
      ? 'TKTEdge'
      : isVictoryLiveHosted
        ? 'Victory Live'
        : 'Broker Nerds';

export const isAdminHosted = window.location.origin.toLowerCase().includes('admin.brokernerds');
